<template>
  <vetalfa-dialog
    :toggleModel="value"
    :bottom="$vuetify.breakpoint.xsOnly"
    :fullscreen="false"
    :height="$vuetify.breakpoint.xsOnly ? null : 370"
    max-width="480px"
    :smallHeader="false"
    :featureMode="false"
    :dialogHeader="{ title: dialogTitle }"
    persistent
    contentClasses="clinical-draft-dialog"
    @dialogClose="$emit('cancel')"
  >
    <div class="clinical-draft-dialog__content px-4 pt-3">
      <p class="body-2 grey--text text--darken-2 mb-4">
        {{ dialogText }}
      </p>
      <v-alert v-if="error" type="error" text dense class="mb-0">
        {{ error }}
      </v-alert>
    </div>

    <template #actions>
      <div class="clinical-draft-dialog__actions px-4 pb-4">
        <template v-if="recovery">
          <v-btn
            color="primary"
            rounded
            block
            class="text-none mb-2"
            :loading="busy"
            @click="$emit('restore')"
          >
            Recuperar para revisão
          </v-btn>
          <v-btn
            outlined
            color="primary"
            rounded
            block
            class="text-none"
            :disabled="busy"
            @click="$emit('discard')"
          >
            Descartar cópia local
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            color="primary"
            rounded
            block
            class="text-none mb-2"
            :loading="busy"
            @click="$emit('keep')"
          >
            Manter rascunho e sair
          </v-btn>
          <v-btn
            outlined
            color="#B42318"
            rounded
            block
            class="text-none mb-2"
            :disabled="busy"
            @click="$emit('discard')"
          >
            Descartar alterações e sair
          </v-btn>
          <v-btn
            text
            rounded
            block
            class="text-none"
            :disabled="busy"
            @click="$emit('cancel')"
          >
            Continuar editando
          </v-btn>
        </template>
      </div>
    </template>
  </vetalfa-dialog>
</template>

<script>
export default {
  name: "ClinicalDraftDialog",
  props: {
    value: Boolean,
    recovery: Boolean,
    busy: Boolean,
    error: String,
    entityLabel: {
      type: String,
      default: "consulta",
    },
  },
  computed: {
    dialogTitle() {
      return this.recovery ? "Recuperar rascunho?" : "O que deseja fazer?";
    },
    dialogText() {
      if (this.recovery) {
        return `Existe uma cópia local desta ${this.entityLabel}. Recupere para continuar ou descarte a cópia. Nada será enviado ao servidor automaticamente.`;
      }
      return `Há alterações nesta ${this.entityLabel} que ainda não foram salvas na conta. Você pode manter o rascunho neste dispositivo por sete dias ou descartar tudo.`;
    },
  },
};
</script>

<style scoped>
.clinical-draft-dialog__content {
  min-height: 92px;
}
.clinical-draft-dialog__actions {
  width: 100%;
}
@media (max-width: 599px) {
  .clinical-draft-dialog__content,
  .clinical-draft-dialog__actions {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .clinical-draft-dialog__actions {
    padding-bottom: max(20px, env(safe-area-inset-bottom)) !important;
  }
}
</style>
